import { render } from "./NotificationDashboard.vue?vue&type=template&id=5bf00c47&scoped=true"
import script from "./NotificationDashboard.vue?vue&type=script&lang=js"
export * from "./NotificationDashboard.vue?vue&type=script&lang=js"

import "./NotificationDashboard.vue?vue&type=style&index=0&id=5bf00c47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf00c47"]])

export default __exports__